import React from 'react';

const CustomerInfoForm = () => <div> CustomerInfoForm</div>;

export default CustomerInfoForm;
